import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { Meeting } from "@common/ADAPT.Common.Model/organisation/meeting";
import { TeamType } from "@common/ADAPT.Common.Model/organisation/team-type";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { IAdaptLinkObject } from "@common/route/route.service";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { ResponsiveService } from "@common/ux/responsive/responsive.service";
import { teamKanbanPageRoute } from "@org-common/lib/kanban/kanban-page/kanban-page.route";
import { MeetingsService } from "@org-common/lib/meetings/meetings.service";
import { MeetingsUiService } from "@org-common/lib/meetings/meetings-ui.service";
import { ObjectivesAuthService } from "@org-common/lib/objectives/objectives-auth.service";
import { ObjectivesRouteService } from "@org-common/lib/objectives/objectives-route.service";
import { StrategyGoalsPageRoute } from "@org-common/lib/strategic-goals/strategic-goals-page/strategic-goals-page.component";
import { StrategyAuthService } from "@org-common/lib/strategy/strategy-auth.service";
import { CommonTeamsAuthService } from "@org-common/lib/teams/common-teams-auth.service";
import { Observable } from "rxjs";
import { filter } from "rxjs/operators";

@Component({
    selector: "adapt-meeting-shortcut-icons",
    templateUrl: "./meeting-shortcut-icons.component.html",
    styleUrl: "./meeting-shortcut-icons.component.css",
    standalone: false,
})
export class MeetingShortcutIconsComponent extends BaseComponent implements OnChanges, OnInit {
    public readonly TeamType = TeamType;
    public readonly ViewTeamKanban = CommonTeamsAuthService.ViewTeamKanban;
    public readonly ViewTeamMeetings = CommonTeamsAuthService.ViewTeamMeetings;
    public readonly ReadObjectivesForTeam = ObjectivesAuthService.ReadObjectivesForTeam;
    public readonly ReadPublicObjectives = ObjectivesAuthService.ReadPublicObjectives;
    public readonly ReadStrategicGoals = StrategyAuthService.ReadStrategicGoals;

    @Input({ required: true }) public meeting!: Meeting;
    @Input() public showText = false;
    private originalShowText = false;

    public canEditTeamMeeting = false;
    public teamWorkUrl$?: Observable<IAdaptLinkObject>;
    public teamMeetingLink$?: Observable<IAdaptLinkObject>;
    public teamObjectivesLink$?: Observable<IAdaptLinkObject>;
    public orgObjectivesLink$?: Observable<IAdaptLinkObject>;
    public strategicGoalsUrl$?: Observable<IAdaptLinkObject>;

    public constructor(
        private meetingsService: MeetingsService,
        private meetingsUiService: MeetingsUiService,
        private objectivesRouteService: ObjectivesRouteService,
        private responsiveService: ResponsiveService,
    ) {
        super();
    }

    public get orgObjectivesText() {
        return this.isAlto ? "Objectives" : "Organisation objectives";
    }

    public ngOnInit() {
        // only toggle showText on resize if text was allowed to show to begin with
        // can't do this with just css as we want the tooltips to show up as well
        this.responsiveService.isMobileSize$.pipe(
            filter(() => this.originalShowText),
            this.takeUntilDestroyed(),
        ).subscribe((isMobileSize) => this.showText = !isMobileSize);
    }

    public ngOnChanges(changes: SimpleChanges) {
        this.originalShowText = changes.showText?.currentValue ?? this.showText;
        this.canEditTeamMeeting = this.meetingsService.canEditMeetingForTeam(this.meeting.team!);
        this.teamWorkUrl$ = teamKanbanPageRoute.getRouteObject({ teamId: this.meeting.teamId });
        this.teamMeetingLink$ = this.meetingsService.getTeamMeetingsPageObj(this.meeting);
        this.teamObjectivesLink$ = this.objectivesRouteService.getObjectivePageRoute(this.meeting.teamId);
        this.orgObjectivesLink$ = this.objectivesRouteService.getObjectivePageRoute();
        this.strategicGoalsUrl$ = StrategyGoalsPageRoute.getRouteObject();
    }

    @Autobind
    public editMeetingAgenda(meeting: Meeting) {
        return this.meetingsUiService.editMeetingAgenda(meeting);
    }
}
